import { MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const TEAM = [
  {
    photo: "/team-corbin.jpg",
    name: "Corbin Lenaway",
    role: "Co-Founder / CEO",
    location: "Peoria, IL",
  },
  {
    photo: "/team-mark.jpg",
    name: "Mark Elliott",
    role: "Co-Founder / CFO",
    location: "Detroit, MI",
  },
];

export const Team = () => (
  <section id="team" className="relative py-20 lg:py-28 bg-panel/30 border-t border-line" data-testid="team-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        kicker="Our Team"
        title={
          <>
            The Engine Behind <span className="text-electric">The Experience</span>
          </>
        }
        sub="Founder-led and hands-on at every event — the people you book are the people who show up."
      />

      <div className="grid sm:grid-cols-2 gap-6 lg:gap-10 mt-14 max-w-3xl mx-auto">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.1}>
            <div
              className="group bg-panel border border-line clip-corner overflow-hidden hover:border-electric/50 transition-colors duration-300"
              data-testid={`team-card-${i}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={m.photo}
                  alt={`${m.name}, ${m.role} of Impact Activations`}
                  loading="lazy"
                  className="w-full aspect-square object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-panel via-transparent to-transparent" />
              </div>
              <div className="p-6 text-center -mt-6 relative">
                <h3 className="font-display text-xl font-bold text-slate-50 uppercase tracking-wide">{m.name}</h3>
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-electric mt-2">{m.role}</p>
                <p className="flex items-center justify-center gap-1.5 text-xs text-slate-400 mt-2.5">
                  <MapPin className="h-3.5 w-3.5 text-slate-500" strokeWidth={1.8} />
                  {m.location}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
